module.exports = __webpack_public_path__ + "static/media/logo.711634b2.png";